import { Component, Prop, h, getMode, Method } from '@stencil/core';

@Component({
  tag: 'ds-navigation-button',
  styleUrls: {
    default: 'ds-navigation-button.scss',
    light: 'ds-navigation-button.scss'
  },
  shadow: true
})
export class DsNavigationButton {
  // eslint-disable-next-line @stencil-community/reserved-member-names
  @Prop() color: 'icon' | 'transparent';
  @Prop() label: string;
  @Prop() disabled: boolean;
  @Prop() accessibilityAttributes?: { expanded?: boolean; hasPopup?: boolean } = {};
  @Prop() isLink?: boolean = false;
  @Prop() href?: string;
  @Prop() type?: string;
  @Prop() target?: string;

  private buttonRef!: HTMLElement;

  @Method()
  async focusBtn() {
    this.buttonRef?.focus();
  }

  render() {
    const mode = getMode(this);
    const ariaAttrs = Object.keys(this.accessibilityAttributes).reduce(
      (r, key) => ({ ...r, [`aria-${key.toLowerCase()}`]: `${this.accessibilityAttributes[key]}` }),
      {}
    );
    return !this.isLink ? (
      <button
        disabled={this.disabled}
        class={this.color}
        aria-label={this.label}
        type={this.type}
        part='element'
        data-mode={mode}
        {...ariaAttrs}
        ref={(element) => (this.buttonRef = element as HTMLElement)}
      >
        <slot></slot>
      </button>
    ) : (
      <a
        class={this.color}
        aria-label={this.label}
        href={this.href}
        target={this.target}
        role='button'
        part='element'
        data-mode={mode}
      >
        <slot></slot>
      </a>
    );
  }
}
